import React, { FC } from "react";
import { useMutation } from "react-query";
import _ from "lodash";
import { DeleteButton } from "../../common/components/DeleteButton";
import { fetchDeleteTaskCounterSubmission } from "../miscellaneous/fetchTaskCounterSubmission";

type Props = {
  id: number;
  info: string;
  tasks: any;
  setTasks: any;
  setTotalRecords?: React.Dispatch<React.SetStateAction<number>>;
};

export const DeleteTaskCounterSubmission: FC<Props> = ({
  id,
  info,
  tasks,
  setTasks,
  setTotalRecords,
}) => {
  const mutationDelete = useMutation(fetchDeleteTaskCounterSubmission, {
    onSuccess: (res) => {
      if (res.status === 200) {
        const tasksFilter = _.filter(tasks, (item: any) => item.id !== id);
        setTasks(tasksFilter);
        setTotalRecords?.((prev) => prev - 1);
      }
    },
  });

  const handleDelete = (event: any) => {
    event.stopPropagation();
    mutationDelete.mutate(id);
  };

  return (
    <DeleteButton
      id={id.toString()}
      title={"Delete Task"}
      info={info}
      onHandleDelete={handleDelete}
      customContent="Are you sure that you want to delete this task?"
    />
  );
};
